var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d;
import 'quill/dist/quill.bubble.css';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import Chat from '@/components/chat/Chat';
import EnvironmentSelect from '@/components/environment-select/EnvironmentSelect';
import Rating from '@/components/rating/Rating';
import ProgressSelect from '@/components/progress-select/ProgressSelect';
import SubjectStatusSelect from '@/components/subject-status-select/SubjectStatusSelect';
import { Curriculum as CurriculumModel } from '@/models/Curriculum';
import { Student } from '@/models/Student';
import { Template } from '@/models/Template';
import { User } from '@/models/User';
import { UserFile } from '@/models/UserFile';
import { UserSubject } from '@/models/UserSubject';
import ErrorHandler from '@/support/ErrorHandler';
import { quilEditorOptionsModules } from '@/support/QuilEditorOptions';
import { formatDate as format, sanitizeString } from '@/support/String';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { quillEditor } from 'vue-quill-editor';
import LoaderCard from '../loader-card/LoaderCard';
import { cloneDeep } from 'lodash';
import { RolesEnum } from '@/items/Roles';
let EditSubjectDialog = class EditSubjectDialog extends Vue {
    constructor() {
        super(...arguments);
        this.subjectTargetClone = new UserSubject();
        this.progress = '00000';
        this.chatUserModel = new User().filter({ roles: ['teacher'] });
        this.subjects = [];
        this.isLoading = true;
        this.guardian_can_use_chat_functions = true;
        this.isEditing = false;
        this.isAchieved = false;
        this.selectedFile = null;
        this.selectedLevel = { value: null };
        this.selectedSubject = null;
        this.selectedTemplate = null;
        this.isTemplateFile = false;
        this.fileInput = null;
        this.oldTextAreaValue = null;
        this.oldSubjectStatus = null;
        this.rating = null;
        this.periodFilter = { type: 'Period', value: '' };
        this.selectedStatuses = {
            highlighted: true,
            busy: true,
            old: true,
            closed: false,
            finished: false,
        };
        this.filters = {};
        this.chat = null;
        this.files = {};
        this.addedByUser = null;
        this.availableAtPeriod = null;
        // Make props
        this.temporary = {
            progressFromApi: '01010',
            // Move to init function
            progress: '01010',
        };
    }
    get editorOptions() {
        return {
            placeholder: this.$t('subject.dialog.achievedNote.placeholder'),
            modules: quilEditorOptionsModules,
        };
    }
    get getPriorityLabel() {
        return this.$store.getters.getSetting('priority_subjects_label') || 'MijnVoorrang';
    }
    get canFinishSubject() {
        if (this.subjectTarget === null) {
            return;
        }
        const subject = this.subjectTarget;
        return !this.isEditing && (subject.status === 'highlighted' || subject.status === 'busy' || subject.status === 'old');
    }
    get canEditProgress() {
        if (!this.$store.state.Auth) {
            return false;
        }
        return this.$store.state.Auth.hasRole([RolesEnum.STUDENT]) || this.isEditing;
    }
    mounted() {
        Object.keys(this.selectedStatuses).forEach((key) => {
            this.$set(this.selectedStatuses, key, this.selectedStatuses[key]);
        });
        this.subjectTargetClone = cloneDeep(this.subjectTarget);
        this.initialize();
        this.setSettings();
    }
    subjectTargetChanged() {
        this.isLoading = true;
        this.chat = null;
        this.files = [];
        if (this.subjectTarget) {
            // @ts-ignore
            const userId = this.subjectTarget.user;
            this.oldTextAreaValue = this.subjectTarget.description;
            this.oldSubjectStatus = this.subjectTarget.status;
            new UserSubject()
                .filter('subjects', [this.subjectTarget.subject])
                .include(['chat', 'files', 'added_by_user', 'available_at_period'])
                .user(userId)
                .first()
                .then((subject) => {
                this.chat = subject.chat || null;
                this.files = subject.files || [];
                this.progress = subject.progress || '00000';
                this.isLoading = false;
                if (subject.added_by_user && !Array.isArray(subject.added_by_user)) {
                    this.addedByUser = subject.added_by_user;
                }
                if (subject.available_at_period && !Array.isArray(subject.available_at_period)) {
                    this.availableAtPeriod = subject.available_at_period;
                }
            });
        }
    }
    initialize() {
        this.subjectTargetChanged();
    }
    getTemplates(id) {
        if (this.$store.state.Auth.hasRole([RolesEnum.GUARDIAN, RolesEnum.STUDENT])) {
            return;
        }
        new Template()
            .subject(id)
            .include('file')
            .all()
            .then((templates) => {
            this.templates = templates;
        });
    }
    onFileChange(event) {
        if (!event.target.files.length || this.subjectTarget === null) {
            return;
        }
        this.fileInput = event.target;
        this.selectedFile = event.target.files[0];
        if (!this.selectedFile) {
            return;
        }
    }
    removeSelectedFile() {
        this.selectedFile = null;
        if (this.fileInput) {
            this.fileInput.removeAttribute('value');
            this.fileInput.setAttribute('value', '');
        }
    }
    deleteFile(file) {
        if (!file.id) {
            return;
        }
        const id = file.id;
        const collection = file.collection;
        new UserFile()
            .setDeleteEndpoint(this.student, file.id)
            .delete()
            .then((response) => {
            if (!collection) {
                return;
            }
            const index = this.files[collection].findIndex((file) => {
                return file.id === id;
            });
            if (index >= 0) {
                const newFiles = [...this.files[collection]];
                newFiles.splice(index, 1);
                this.$set(this.files, collection, newFiles);
            }
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    subjectStatusClasses(subject) {
        return {
            highlighted: subject.status === 'highlighted',
            busy: subject.status === 'busy',
            old: subject.status === 'old',
            closed: subject.status === 'closed',
            finished: subject.status === 'finished',
        };
    }
    updateStatus(subject, status, meta = {}) {
        // { description: subjectTarget.description, environment: subjectTarget.environment }
        const payload = {
            ...meta,
            ...{
                subject: subject.subject,
                status,
                progress: this.progress,
                description: subject.description,
            },
        };
        this.$emit('previousSubjectStatus', subject.status);
        new UserSubject()
            .user(this.student)
            .put([payload])
            .then((userSubject) => {
            subject.status = status;
            subject.progress = this.progress;
            subject.is_marked_as_finished_by_student = false;
            this.$emit('progressUpdated', this.progress);
            this.$emit('subjectUpdated', payload);
        });
        if (this.selectedFile) {
            const collection = status === 'finished' ? status : 'default';
            const file = this.isTemplateFile ? this.selectedFile.links.download : this.selectedFile;
            const payload = [];
            const filesArray = this.files[collection];
            filesArray.forEach((file) => {
                if (file.links && file.links.download) {
                    payload.push({
                        file: file.links.download,
                        collection: file.collection || 'default',
                    });
                }
            });
            payload.push({ file, collection });
            new UserSubject()
                .setSubjectId(subject.id || '')
                .user(this.student)
                .uploadFile(payload).then((response) => {
                this.$set(this.files, collection, response.data);
            });
            this.selectedFile = null;
        }
        this.oldTextAreaValue = this.subjectTarget.description;
        this.oldSubjectStatus = this.subjectTarget.status;
    }
    highlightProgress(step) { }
    setFinished(subject, rating) {
        this.updateStatus(subject, 'finished', {
            finished_note: subject.finished_note,
            rating: rating ? rating : 0,
        });
        if (this.selectedFile) {
            const collection = status === 'finished' ? status : 'default';
            const file = this.isTemplateFile ? this.selectedFile.links.download : this.selectedFile;
            const payload = [];
            const filesArray = this.files[collection];
            filesArray.forEach((file) => {
                if (file.links && file.links.download) {
                    payload.push({
                        file: file.links.download,
                        collection: file.collection || 'default',
                    });
                }
            });
            payload.push({ file, collection });
            subject.uploadFile(payload).then((response) => {
                this.$set(this.files, collection, response.data);
            });
            this.selectedFile = null;
        }
    }
    selectTemplate(template) {
        this.selectedTemplate = null;
        if (!this.subjectTarget) {
            return;
        }
        const subject = this.subjectTarget;
        subject.description = template.value;
        if (template.file && template.file.links && template.file.links.download) {
            this.isTemplateFile = true;
            this.selectedFile = template.file;
        }
    }
    closeSubjectDialog() {
        this.isAchieved = false;
        this.$emit('input', false);
    }
    resetTextValue() {
        this.subjectTarget.description = this.oldTextAreaValue || '';
        this.subjectTarget.status = this.oldSubjectStatus || '';
        this.resetProgressValue();
    }
    setSettings() {
        if (this.$store.state.Auth.hasRole([RolesEnum.GUARDIAN])) {
            const guardianCanUseChatFunctions = this.$store.state.settings.find((setting) => setting.key === 'guardian_can_use_chat_functions');
            if (guardianCanUseChatFunctions) {
                this.guardian_can_use_chat_functions = guardianCanUseChatFunctions.value === '1' || guardianCanUseChatFunctions.value === true ? true : false;
            }
        }
    }
    // Move to resetTextValue.
    resetProgressValue() {
        this.temporary.progress = this.temporary.progressFromApi;
    }
    async onClickMarkAsPriority(prio) {
        if (!(this.student && this.student.id)) {
            return;
        }
        if (!(this.subjectTarget && this.subjectTarget.subject)) {
            return;
        }
        const response = await this.updatePriority(this.student.id, this.subjectTarget.subject, prio);
        if (response) {
            this.subjectTargetClone.has_priority = prio;
            this.$emit('subjectUpdated', {
                subject: this.subjectTarget.subject,
                has_priority: prio,
            });
        }
    }
    async updatePriority(userId, subjectId, priority) {
        return await new UserSubject()
            .user(userId)
            .putSubject([{
                subject: subjectId,
                has_priority: priority,
            }]);
    }
    getSetting(key) {
        return this.$store.getters.getSetting(key);
    }
    // protected isCompletedStep(step: number) {
    //   return step <= this.progress;
    // }
    subjectStatusLabel(status) {
        if (!status) {
            return this.$tc(`idp.status.inactive`, 2);
        }
        const label = this.$store.state.labels.find((label) => {
            return label.key === status;
        });
        if (!label || label.value === label.key) {
            return this.$tc(`idp.status.${status}`, 2);
        }
        else {
            return label.value;
        }
    }
    updateUserSubject(subject, status, value, key) {
        const payload = [{
                ...{ subject: subject.subject, status,
                    progress: this.progress,
                    description: subject.description,
                    has_requested_help: subject.has_requested_help,
                    is_marked_as_finished_by_student: subject.is_marked_as_finished_by_student, },
                ...{ [key]: value },
            }];
        new UserSubject()
            .user(this.student)
            .put(payload)
            .then(() => {
            subject[key] = value;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    newRating(rating) {
        this.rating = rating;
    }
    onProgressUpdated(progress) {
        this.progress = progress;
        if (!this.$store.state.Auth || !this.$store.state.Auth.hasRole([RolesEnum.STUDENT])) {
            return;
        }
        this.updateStatus(this.subjectTarget, this.subjectTarget.status || '', {
            has_requested_help: this.subjectTarget.has_requested_help,
            is_marked_as_finished_by_student: this.subjectTarget.is_marked_as_finished_by_student,
        });
    }
    sanitizeString(value) {
        return sanitizeString(value);
    }
    ratingChanged(newRating) {
        this.subjectTarget.rating = newRating;
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof CurriculumModel !== "undefined" && CurriculumModel) === "function" ? _a : Object)
], EditSubjectDialog.prototype, "curriculum", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_b = typeof Student !== "undefined" && Student) === "function" ? _b : Object)
], EditSubjectDialog.prototype, "student", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_c = typeof UserSubject !== "undefined" && UserSubject) === "function" ? _c : Object)
], EditSubjectDialog.prototype, "subjectTarget", void 0);
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], EditSubjectDialog.prototype, "templates", void 0);
__decorate([
    Watch('subjectTarget'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], EditSubjectDialog.prototype, "subjectTargetChanged", null);
__decorate([
    Watch('selectedTemplate'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_d = typeof Template !== "undefined" && Template) === "function" ? _d : Object]),
    __metadata("design:returntype", void 0)
], EditSubjectDialog.prototype, "selectTemplate", null);
__decorate([
    Watch('rating'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], EditSubjectDialog.prototype, "ratingChanged", null);
EditSubjectDialog = __decorate([
    Component({
        components: {
            Chat,
            EnvironmentSelect,
            SubjectStatusSelect,
            quillEditor,
            LoaderCard,
            Rating,
            ProgressSelect,
        },
        filters: {
            formatDate(date) {
                return !date ? '' : format(date, 'dd-LL-yyyy HH:mm');
            },
        },
    })
], EditSubjectDialog);
export default EditSubjectDialog;
